// extracted by mini-css-extract-plugin
module.exports = {"loader":"appLoader__loader___38V1L"};